import React from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {OnboardingBeneficiaryContext} from 'context';
import {BeneficiaryInfo} from 'commons/types/Types';

EfeBeneficiaryProvider.propTypes = {children: PropTypes.node.isRequired};

function EfeBeneficiaryProvider(props: InferProps<typeof EfeBeneficiaryProvider.propTypes>) {
    const {children} = props;
    const [percentageCompleted, setPercentageCompleted] = React.useState<number>(0);
    const [beneficiaries, setBeneficiaries] = React.useState<Array<BeneficiaryInfo>>([]);
    const [tempBeneficiary, setTempBeneficiary] = React.useState<BeneficiaryInfo | undefined>();
    const [authorization, setAuthorization] = React.useState<boolean>(false);
    const [isActive, setActive] = React.useState<boolean>(false);

    function resetBeneficiaryContext() {
        setPercentageCompleted(0);
        setBeneficiaries([]);
        setAuthorization(false);
        setTempBeneficiary(undefined);
        setActive(false);
    }

    return (
        <OnboardingBeneficiaryContext.Provider
            value={{
                setPercentageCompleted,
                setBeneficiaries,
                setTempBeneficiary,
                setActive,
                percentageCompleted,
                beneficiaries,
                tempBeneficiary,
                isActive,
                resetBeneficiaryContext,
                authorization,
                setAuthorization,
            }}>
            {children}
        </OnboardingBeneficiaryContext.Provider>
    );
}

export default EfeBeneficiaryProvider;
